<template>
  <div class="newsTrends">

    <div class="body-content">

      <div class="shisanwu">
        <div class="shisanwu-body">
          <div class="body-left">
            <img src="../../assets/images/newsTrends/新闻@2x.png" alt="">
          </div>
          <div class="body-right">
            <div class="tabs-box" v-if="mainMessage.secondThemeVOList">
              <ul class="tabs">
                <li class="tab" v-for="(item, index) in mainMessage.secondThemeVOList"
                :class="{active: tab1 === index}"
                @click="tab1 = index" :key="item.id">{{item.secondThemeName}}</li>
              </ul>
              <div class="more pointer" @click="more">
                更多<i class="el-icon-arrow-right"></i>
              </div>
            </div>
            <ul class="list" v-for="(item, index) in mainMessage.secondThemeVOList" v-show="tab1 === index" :key="item.id">
              <li v-for="i in item.noticeList" :key="i.id" class="active">
                <a :href="'/newsDetail?id=' + i.id">
                  <div class="item-content">
                    <span class="text pointer">{{i.title}}</span>
                    <span class="date">{{i.publishTime || i.createTime}}</span>
                  </div>
                  <div class="subText">{{i.brief}}</div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="outcome">
        <div class="outcome-body">
          <div class="outcome-body-scroll">
            <ul>
              <li v-for="(fruit,index) in imgs" :key="index">
                <a>
                  <img v-if="index===0||index===4||index===5||index===6" :src="'../../../static/images/' + (index+1) + '.png'" alt="">
                  <img v-if="index==1||index===2||index===3" :src="'../../../static/images/' + (index+1) + '.jpg'" alt="">
                  <span>{{fruit.name}}</span>
                </a>
              </li>
            </ul>
          </div>
          <div class="content">
<!--            <div class="content-item">
              <a :href="'/newsDetail?id=' + impFruitInfo.secondThemeVOList[1].noticeList[0].id">
                <p class="title">{{impFruitInfo.secondThemeVOList[1].noticeList[0].title}}</p>
                <p class="text">{{impFruitInfo.secondThemeVOList[1].noticeList[0].brief}}</p>
              </a>
            </div>-->
          </div>
          <div class="prev-icon" :class="scrollIndex==0?'disabled':''" @click="scrollIndex--">
            <img src="../../assets/images/home/arrow-left.png" alt="">
          </div>
          <div class="next-icon" :class="scrollIndex>(impFruitList.length-5)?'disabled':''" @click="scrollIndex++">
            <img src="../../assets/images/home/arrow-right.png" alt="">
          </div>
        </div>
      </div>

      <div class="body-container">
        <div class="body-content">
          <div class="content-function">
            <div class="carousel-show">
              <div class="title">NQI专项5项成果亮相国家“十三五”科技创新成就展</div>
              <div class="content">
                2021年10月21日至27日，国家“十三五”科技创新成就展在北京展览馆举办。玻尔兹曼常数的精确测定等5项NQI专项科研成果亮相展览。参展的5项NQI成果分别为：玻尔兹曼常数的精确测定、新一代时间标尺和传递技术应对秒定义变革、极区海洋重力校准技术、空间导航与定位NQI技术集成及示范应用以及跨境食品品质及身份特征识别检测技术。这些成果展现了NQI专项“十三五”期间在基础研究和科技创新方面取得的代表性成就。
                <span class="sub-link"><a href="/newsDetail?id=1512236699426410497"><b>阅读更多</b></a></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 媒体聚集 -->
      <div class="media-gathered">
        <div class="title-box">
          <span class="line"></span>
          <span class="title">相关资源</span>
          <span class="line"></span>
        </div>
      </div>

      <!-- 行业要问 -->
      <div class="important-news">
        <div class="left-content-function">
          <div class="content-function">
            <div class="function-text">
              <div class="texts-left">相关机构</div>
            </div>
            <div class="organization-list">
              <div class="item"><a href="https://www.nim.ac.cn/" target="_blank">中国计量科学研究院</a></div>
              <div class="item"><a href="https://www.cnis.ac.cn/pcindex/" target="_blank">中国标准化研究院</a></div>
              <div class="item"><a href="http://www.caiq.org.cn/" target="_blank">中国检验检疫科学研究院</a></div>
              <div class="item"><a href="https://www.csei.org.cn/" target="_blank">中国特种设备检测研究院</a></div>
              <div class="item"><a href="https://www.cnas.org.cn/" target="_blank">中国合格评定国家认可中心</a></div>
            </div>
          </div>
        </div>
        <div class="left-content-function" v-if="false">
          <div class="content-function">
            <div class="function-text">
              <div class="texts-left">{{techNotice.firstThemeName || '成果概览'}}</div>
              <span class="texts-right">
                更多<i class="el-icon-arrow-right"></i>
              </span>
            </div>
            <div class="carousel-show">
              <div class="carousel-overall column" v-if="techNotice.secondThemeVOList">
                <div class="tab-nav">
                  <ul>
                    <li v-for="(item, index) in techNotice.secondThemeVOList"
                    :key="'news4'+index"
                    :class="news4===index?'active':''"
                    @click="news4=index">{{item.secondThemeName}}</li>
                  </ul>
                </div>
                <div class="tab-content">
                  <ul v-for="(item, index) in techNotice.secondThemeVOList"
                  :key="'news4Content' + index"
                  v-show="news4===index">
                    <li v-for="i in item.noticeList" :key="i.id">
                      <a :href="'/newsDetail?id=' + i.id">
                      {{i.title}}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="right-content-function">
          <div class="content-function">
            <div class="function-text">
              <div class="texts-left">{{lawInfo.firstThemeName}}</div>
              <span class="texts-right" @click="zcfgMore" style="cursor: pointer;">
                更多<i class="el-icon-arrow-right"></i>
              </span>
            </div>
            <div class="carousel-show">
              <div class="carousel-overall column" v-if="lawInfo.secondThemeVOList">
                <div class="tab-nav" v-if="false">
                  <ul>
                    <li v-for="(item,index) in lawInfo.secondThemeVOList"
                    :key="item.id"
                    :class="news3===index?'active':''" @click="news3=index">{{item.secondThemeName}}</li>
                  </ul>
                </div>
                <div class="tab-content">
                  <ul v-for="(item, index) in lawInfo.secondThemeVOList"
                  :key="'news3Content' + index"
                  v-show="news3===index">
                    <li v-for="i in item.noticeList" :key="i.id">
                      <a :href="'/newsDetail?id=' + i.id">{{i.title}}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ISO -->
      <div class="ISO" v-if="false">
        <div class="ISO-box" v-for="hl in highlights" :key="hl.id">
          <div class="ISO-header">
            <div class="texts-left">{{hl.secondThemeName}}</div>
              <span class="texts-right pointer">
                更多<i class="el-icon-arrow-right"></i>
              </span>
          </div>
          <div class="creative-content">
            <p class="active" v-for="h in hl.noticeList" :key="'hl'+h.id">
              <a :href="'/newsDetail?id=' + h.id">
              <span class="title pointer">{{h.title}}</span>
              <span class="text">{{h.brief}}</span>
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'newsTrends',
  data () {
    return {
      fileUrl: '',
      tab1: 0,
      mainMessage: [],
      impFruitList: [],
      impFruitInfo: {},
      news3: 0,
      news4: 0,
      techNotice: {},
      scrollIndex: 0,
      lawInfo: {},
      highlights: [],
      imgs: [{
        name: '全球玻尔兹曼常数测定结果'
      }, {
        name: '圆柱声学法核心部件-精密声学谐振腔'
      }, {
        name: '锶原子光晶格钟实验系统'
      }, {
        name: '锶原子光晶格钟核心部件——磁光阱'
      }, {
        name: '北斗时间远程传递装置'
      }, {
        name: '北斗时间传递比对及效果评估'
      }, {
        name: 'NIM-3C型激光干涉绝对重力仪'
      }]
    }
  },
  created () {
    this.fileUrl = FileUrl;
    this.fetchMessage();
    this.fetchImpFruit();
  },
  watch: {
    scrollIndex: function (val) {
      const _self = this;
      if (val < 0) _self.scrollIndex = 0;
      if (val > _self.impFruitList.length - 4) _self.scrollIndex = _self.impFruitList.length - 4;
      $('.outcome-body-scroll ul').css('margin-left', -296 * _self.scrollIndex + 'px');
    }
  },
  methods: {
    fetchMessage () {
      this.fetch('/dataapi/open/nqi/notice/getNoticeNewsList').then(res => {
        this.mainMessage = res.result;
      });
      this.fetch('/dataapi/open/nqi/notice/getImportNewsInfo').then(res => {
        this.techNotice = res.result;
      });
      this.fetch('/dataapi/open/nqi/notice/getLawList').then(res => {
        this.lawInfo = res.result;
      });
      this.fetch('/dataapi/open/nqi/notice/getResearchPointInfo').then(res => {
        this.highlights = res.result.secondThemeVOList
      });
    },
    fetchImpFruit () {
      this.post('/dataapi/open/nqi/fruit/listImportFruit').then(res => {
        this.impFruitList = res.result;
        $('.outcome-body-scroll').find('ul').width(296 * this.impFruitList.length);
      });
      this.fetch('/dataapi/open/nqi/notice/getImportFruitInfo').then(res => {
        this.impFruitInfo = res.result;
      });
    },
    // 跳转链接
    navToPath (path) {
      this.$router.push({ path });
    },
    changeNews (type, value) {
      const _self = this;
      if (_self['news' + type] === value) return;
      _self['news' + type] = value;
    },
    more () {
      this.$router.push({path: '/notice', query: {id: 1}});
    },
    // cgglMore () {
    //   this.$router.push({path: '/notice', query: {id: 4}});
    // },
    zcfgMore () {
      this.$router.push({path: '/notice', query: {id: 6}});
    }
    // gjhzMore (name) {
    //   this.$router.push({path: '/notice', query: {secondId: 17, name: name}});
    // }
  }
};
</script>

<style lang="less" scoped>
.body-content {
  width: @body-width;
  margin: 0 auto;
  background-color: #fff;
  a {
    color: inherit;
    &:hover {
      text-decoration: none;
    }
  }
}
.pointer {
  cursor: pointer;
  &:hover {
    color: red;
    color: rgba(19, 107, 174, 1)!important;
  }
}

.newsTrends {
  width: 100%;
  padding-top: 30px;
  background-color: rgba(246, 247, 251, 1);
  .shisanwu {
    padding: 30px 24px 0 26px;
    padding-bottom: 61px;
    .shisanwu-body {
      display: flex;
      .body-left {
        flex: 0 0 400px;
        height: 300px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .body-right {
        flex: 1;
        .tabs-box {
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-top: 2px solid rgba(46, 92, 154, 1);
          background-color: rgba(246, 247, 251, 1);
        }
        .tabs {
          display: flex;
          .tab {
            height: 56px;
            line-height: 56px;
            padding: 0 16px;
            text-align: center;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 500;
            color: rgba(46, 92, 154, 1);
            cursor: pointer;
            &.active {
              color: #fff;
              background-color: rgba(46, 92, 154, 1);
            }
          }
        }
        .more {
          padding-right: 16px;
          font-size: 14px;
          color: rgba(143, 143, 143, 1);
          img {
            width: 10px;
            margin-left: 6px;
          }
        }
        .list {
          width: 100%;
          padding-top: 12px;
          li {
            margin-bottom: 24px;
            padding-left: 20px;
            padding-right: 31px;
            box-sizing: border-box;
            &:last-child {
              margin-bottom: 0;
            }
            &.active {
              .item-content {
                margin-bottom: 9px;
                .text {
                  font-size: 16px;
                  font-weight: 500;
                  color: rgba(46, 92, 154, 1);
                }
              }
              .subText {
                padding-left: 42px;
                font-size: 14px;
                color: rgba(46, 92, 154, 1);
                line-height: 20px;
              }
            }
            .item-content {
              display: flex;
              align-items: center;
              justify-content: space-between;
              .text {
                position: relative;
                padding-left: 16px;
                box-sizing: border-box;
                font-size: 14px;
                color: rgba(0, 0, 0, 0.85);
                line-height: 20px;
                &::before {
                  content: '';
                  position: absolute;
                  top: 50%;
                  left: 0;
                  z-index: 1;
                  transform: translateY(-50%);
                  width: 4px;
                  height: 4px;
                  border-radius: 50%;
                  background-color: rgba(46, 92, 154, 1);
                }
              }
              .date {
                font-size: 14px;
                color: rgba(143, 143, 143, 1);
                line-height: 20px;
                width: 80px;
                text-align: right;
              }
            }
          }
        }
      }
    }
  }

  .outcome {
    padding-bottom: 40px;
    .outcome-body {
      position: relative;
      padding: 20px 48px;
      background-color: #fff;
      .outcome-body-scroll {
        overflow: hidden;
        ul {
          margin-bottom: 20px;
          height: 200px;
          overflow: hidden;
          li {
            position: relative;
            float: left;
            width: 280px;
            height: 200px;
            overflow: hidden;
            margin: 0 8px;
            a {
              display: block;
              width: 100%;
              height: 100%;
            }
            img {
              width: 100%;
              max-height: 100%;
            }
            span {
              position: absolute;
              left: 0;
              bottom: 0;
              z-index: 1;
              width: 100%;
              height: 40px;
              line-height: 40px;
              text-align: center;
              font-size: 16px;
              color: #fff;
              background-color: rgba(46, 92, 154, 1);
            }
          }
        }
      }
      .content {
        display: flex;
        .content-item {
          flex: 1;
          .title {
            text-align: center;
            height: 16px;
            padding-left: 8px;
            font-size: 16px;
            font-weight: bold;
            color: rgba(0, 0, 0, 0.85);
            line-height: 16px;
            border-left: 6px solid rgba(212, 59, 54, 1);
          }
          .text {
            font-size: 14px;
            color: rgba(0, 0, 0, 0.65);
            line-height: 20px;
            text-indent: 2em;
          }
        }
      }
      .prev-icon {
        position: absolute;
        top: 80px;
        left: 0;
        z-index: 1;
        width: 30px;
        height: 60px;
        line-height: 60px;
        text-align: center;
        background-color: rgba(46, 92, 154, 1);
        cursor: pointer;
        img {
          width: 20px;
        }
        &.disabled {
          background-color: rgba(46, 92, 154, .1);
        }
      }
      .next-icon {
        position: absolute;
        top: 80px;
        right: 0;
        z-index: 1;
        width: 30px;
        height: 60px;
        line-height: 60px;
        text-align: center;
        background-color: rgba(46, 92, 154, 1);
        cursor: pointer;
        img {
          width: 20px;
        }
        &.disabled {
          background-color: rgba(46, 92, 154, .1);
        }
      }
    }
  }

  .body-container {
    width: 100%;
    margin-bottom: 30px;
    .body-content {
      .carousel-show {
        overflow: hidden;
        .title {
          text-align: center;
          font-size: 24px;
          font-weight: bold;
          margin-bottom: 12px;
        }
        .content {
          font-size: 20px;
          line-height: 32px;
          text-indent: 2em;
          padding: 0 24px;
          .sub-link {
            color: #FEA500;
            cursor: pointer;
            text-decoration: underline;
            font-size: 14px;
            font-weight: bold;
          }
        }
      }
    }
  }

  .media-gathered {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 40px;
    width: 100%;
    height: 50px;
    padding: 13px 0;
    box-sizing: border-box;
    background-color: rgba(19, 107, 174, 1);
    .title-box {
      display: flex;
      align-items: flex-end;
      justify-content: center;
    }
    .line {
      margin-bottom: 6px;
      width: 30px;
      height: 2px;
      background-color: rgba(255, 255, 255, .9);
    }
    .title {
      margin: 0 10px;
      font-size: 18px;
      color: #fff;
      font-weight: 500;
    }
  }

  .important-news {
    display: flex;
    padding: 0 24px 60px 24px;
    box-sizing: border-box;
    justify-content: space-between;
    .left-content-function {
      width: 400px;
    }
    .right-content-function {
      width: 800px;
    }
    .left-content-function,
    .right-content-function {
      .function-text {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;
        .texts-left {
          font-size: 24px;
          font-weight: 500;
          color: #000;
          line-height: 33px;
          padding-bottom: 6px;
          border-bottom: 2px solid rgba(46, 92, 154, 1);
        }
        .texts-right {
          padding-right: 14px;
          font-size: 14px;
          color: rgba(143, 143, 143, 1);
          line-height: 20px;
          img {
            margin-left: 5px;
            width: 10px;
          }
        }
      }
      .tab-nav {
        border-top: 2px solid @color-base;
        background-color: rgba(246, 247, 251, 1);
        position: relative;
        z-index: 1;
        ul {
          display: flex;
          list-style: none;
          li {
            cursor: pointer;
            height: 56px;
            line-height: 56px;
            padding: 0 16px;
            transition: all .3s;
            font-size: 16px;
            font-weight: bold;
            color: #2E5C9A;
            &:hover {
              background-color: @color-base;
              color: #ffffff;
            }
            &.active {
              background-color: @color-base;
              color: #ffffff;
            }
          }
        }
      }
      .tab-content {
        background-color: #ffffff;
        border: 1px solid rgba(0, 0, 0, .1);
        padding: 0 20px;
        position: relative;
        flex: 1;
        overflow: hidden;
        ul {
          li:before{
            content: "\2022";     //圆点
            color: rgba(46, 92, 154, 1);       //颜色
            font-size: 16px;
            padding-right: 8px;         //大小
          }
          li {
            font-size: 16px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.85);
            border-bottom: 1px solid #eee;
            cursor: pointer;
            height: 60px;
            line-height: 60px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            padding-right: 30px;
            position: relative;
            a {
              color: rgba(0, 0, 0, 0.85);
            }
            &:last-child {
              border-bottom: 0;
            }
            &:hover a {
              color: @color-base;
            }
            .right-time {
              position: absolute;
              right: 0;
              top: 0;
              color: rgba(143, 143, 143, 1);
              font-size: 14px;
            }
          }
        }
        .tab-content-inner {
          .text {
            display: block;
            text-indent: 28px;
            li {
              border-bottom: 0 none;
              cursor: text;
              line-height: 20px;
              height: 20px;
              &:hover {
                color: inherit;
              }
            }
          }
        }
      }
      .organization-list {
        .item {
          margin-bottom: 15px;
          width: 400px;
          height: 60px;
          border-radius: 6px;
          line-height: 60px;
          text-align: center;
          text-decoration: none;
          font-size: 22px;
          font-weight: bold;
          color: #fff;
          letter-spacing: 2px;
          text-shadow: 1px 1px 0px #2E5C9A;
          cursor: pointer;
          &:nth-child(1) {
            background-color: rgba(125, 191, 237, 1);
          }
          &:nth-child(2) {
            background-color: rgba(126, 159, 217, 1);
          }
          &:nth-child(3) {
            background-color: rgba(124, 196, 253, 1);
          }
          &:nth-child(4) {
            background-color: rgba(109, 180, 205, 1);
          }
          &:nth-child(5) {
            margin-bottom: 0;
            background-color: #6DD6EC;
          }
        }
      }
    }
  }

  .ISO {
    display: flex;
    justify-content: space-between;
    padding: 0 24px 30px 24px;
    box-sizing: border-box;
    flex-flow: wrap;
    .ISO-box {
      width: 600px;
      /*height: 264px;*/
      .ISO-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;
        .texts-left {
          font-size: 24px;
          font-weight: 500;
          color: #000;
          line-height: 33px;
          padding-bottom: 6px;
          border-bottom: 2px solid rgba(46, 92, 154, 1);
        }
        .texts-right {
          padding-right: 14px;
          font-size: 14px;
          color: rgba(143, 143, 143, 1);
          line-height: 20px;
          img {
            margin-left: 5px;
            width: 10px;
          }
        }
      }
      .image {
        margin-bottom: 12px;
        width: 100%;
        height: 140px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .content {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.65);
        line-height: 20px;
      }
    }
  }
  .creative-content {
    p {
      margin-bottom: 12px;
      overflow: hidden;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      text-overflow: ellipsis;
      max-height: 44px;
      display: -webkit-box;
      &.active {
        .title {
          margin-bottom: 8px;
          font-size: 16px;
          line-height: 22px;
          color: rgba(46, 92, 154, 1);
          font-weight: 500;
        }
        .text {
          padding-right: 20px;
          text-indent: 2em;
          font-size: 12px;
          font-weight: 400;
          color: rgba(46, 92, 154, 1);
          line-height: 17px;
          box-sizing: border-box;
        }
      }
      .title {
        font-size: 14px;
        line-height: 20px;
        color: rgba(0, 0, 0, 0.65);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/newsTrends/index.vue